import { render, staticRenderFns } from "./word.vue?vue&type=template&id=f91f90c6&scoped=true&"
import script from "./word.vue?vue&type=script&lang=js&"
export * from "./word.vue?vue&type=script&lang=js&"
import style0 from "./word.vue?vue&type=style&index=0&id=f91f90c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91f90c6",
  null
  
)

export default component.exports